<template>
	<multiselect v-model="inputValue"
							 :placeholder="placeholder"
							 :options="optionItems"
							 :track-by="optionTrackBy"
							 :label="optionLabel"
							 :class="inputClassListLive"
							 :taggable="false"
							 :disabled="disabled || readonly"
							 :show-labels="false"
							 :allow-empty="false"
							 @input="onInputHandler">
		<template slot="vueSelectLabel" slot-scope="{ option }">{{ option.name }}</template>
	</multiselect>
</template>

<script>
import {baseInput} from '../mixins';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
	name: 'SelectObjectInput',
	components: {
		Multiselect
	},
	props: {
		asyncFind: {type: Function, required: false},
		options: {type: Array, required: false, default: () => []},
		multiple: {type: Boolean, required: false, default: true},
		taggable: {type: Boolean, required: false, default: false},
		optionLabel: {type: String, required: false, default: 'name'},
		optionTrackBy: {type: String, required: false, default: 'id'},
	},
	mixins: [baseInput],
	data() {
		return {
			inputValue: null,
			hasFocus: false,
			isLoading: false,
			asyncOptions: []
		}
	},
	computed: {
		optionItems() {
			return this.asyncFind ? this.asyncOptions : this.options;
		},
		inputClassListLive() {
			return this.inputClassList;
		},
	}
};
</script>
